import addMount from "../../core/addMount";
import recommendation from "./recommendation.entry";

addMount({ appName: "recommendation", app: recommendation });
